import { SalaryStructureDto } from './salary-structure-dto.model';


export class SalaryStructureDetailDto implements ISalaryStructureDetailDto {
    id!: number;
    salaryStructure!: SalaryStructureDto;
    fromAmount!: number;
    toAmount!: number;
    basicAlw!: string | undefined;
    dearnessAlw!: string | undefined;
    houseRentAlw!: string | undefined;
    medicalAlw!: string | undefined;
    dailyTravellingAlw!: string | undefined;
    performanceAlw!: string | undefined;
    otherAlw!: string | undefined;
    productionAlw!: string | undefined;
    fuelAlw!: string | undefined;
    isPFDetectable!: boolean;
    isESICDetectable!: boolean;
    isPTDetectable!: boolean;
    isLWFDetectable!: boolean;

    constructor(data?: ISalaryStructureDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.salaryStructure = _data["salaryStructure"] ? SalaryStructureDto.fromJS(_data["salaryStructure"]) : <any>undefined;
            this.fromAmount = _data["fromAmount"];
            this.toAmount = _data["toAmount"];
            this.basicAlw = _data["basicAlw"];
            this.dearnessAlw = _data["dearnessAlw"];
            this.houseRentAlw = _data["houseRentAlw"];
            this.medicalAlw = _data["medicalAlw"];
            this.dailyTravellingAlw = _data["dailyTravellingAlw"];
            this.performanceAlw = _data["performanceAlw"];
            this.otherAlw = _data["otherAlw"];
            this.productionAlw = _data["productionAlw"];
            this.fuelAlw = _data["fuelAlw"];
            this.isPFDetectable = _data["isPFDetectable"];
            this.isESICDetectable = _data["isESICDetectable"];
            this.isPTDetectable = _data["isPTDetectable"];
            this.isLWFDetectable = _data["isLWFDetectable"];
        }
    }

    static fromJS(data: any): SalaryStructureDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new SalaryStructureDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["salaryStructure"] = this.salaryStructure ? this.salaryStructure.toJSON() : <any>undefined;
        data["fromAmount"] = this.fromAmount;
        data["toAmount"] = this.toAmount;
        data["basicAlw"] = this.basicAlw;
        data["dearnessAlw"] = this.dearnessAlw;
        data["houseRentAlw"] = this.houseRentAlw;
        data["medicalAlw"] = this.medicalAlw;
        data["dailyTravellingAlw"] = this.dailyTravellingAlw;
        data["performanceAlw"] = this.performanceAlw;
        data["otherAlw"] = this.otherAlw;
        data["productionAlw"] = this.productionAlw;
        data["fuelAlw"] = this.fuelAlw;
        data["isPFDetectable"] = this.isPFDetectable;
        data["isESICDetectable"] = this.isESICDetectable;
        data["isPTDetectable"] = this.isPTDetectable;
        data["isLWFDetectable"] = this.isLWFDetectable;
        return data; 
    }
}

export interface ISalaryStructureDetailDto {
    id: number;
    salaryStructure: SalaryStructureDto;
    fromAmount: number;
    toAmount: number;
    basicAlw: string | undefined;
    dearnessAlw: string | undefined;
    houseRentAlw: string | undefined;
    medicalAlw: string | undefined;
    dailyTravellingAlw: string | undefined;
    performanceAlw: string | undefined;
    otherAlw: string | undefined;
    productionAlw: string | undefined;
    fuelAlw: string | undefined;
    isPFDetectable: boolean;
    isESICDetectable: boolean;
    isPTDetectable: boolean;
    isLWFDetectable: boolean;
}

